import React from "react";
import BasePage from "./BasePage";
import {DealsList} from "@ui";
import styled, {useTheme} from "styled-components";
import Title from "src/core/common/components/modules/Title";
import merge from "lodash/merge";

export default function ColourfulDealsPage({rewards, meta, siteName, ...props}) {
  const _theme = useTheme();

  const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.showcasedProductsList)};

  const TitleComponent = () => {
    return <span>Awaiting offers</span>;
  };

  const TextComponent = () => {
    return (
      <>
        <span>No deals are available at the moment!</span>
        <span>Please come back another day for great deals.</span>
      </>
    );
  };

  return (
    <BasePage {...props}>
      <Container>
        <DealsList
          styles={CardStyles(theme)}
          skeleton={meta.loading && rewards.length === 0}
          deals={rewards}
          noResultsPlaceholderProps={{
            styles: getNoResultsStyles(theme),
            TitleComponent: TitleComponent,
            TextComponent: TextComponent,
          }}
          headerProps={{
            TitleComponent: Title,
            styles: headerStyles(theme),
            title: `${siteName} Deals For Everyone`,
            description:
              "Check out all of our current cannabis deals below and find a robust offering of deals and rewards is the best way to say thanks for your loyal support.",
          }}
        />
      </Container>
    </BasePage>
  );
}

const CardStyles = (theme) => ({
  card: {
    root: {
      borderRadius: {
        lg: theme.v2.decoration.border.radius.default,
        md: theme.v2.decoration.border.radius.default,
        sm: theme.v2.decoration.border.radius.default,
      },
    },
    title: {
      fontFamily: theme.v2.typography.title1.family,
      color: theme.v2.color.onBackground,
      fontWeight: theme.v2.typography.title1.weight,
      fontSize: {
        lg: "14px",
        md: "14px",
        sm: "14px",
      },
    },
    description: {
      fontFamily: theme.v2.typography.bodyText1.family,
      color: theme.v2.color.onBackground,
      fontWeight: theme.v2.typography.bodyText1.weight,
      fontSize: {
        lg: "14px",
        md: "14px",
        sm: "14px",
      },
    },
    required: {
      fontFamily: theme.v2.typography.bodyText1.family,
      color: "#6B6C6F",
      fontWeight: theme.v2.typography.bodyText1.weight,
      fontSize: {
        lg: "14px",
        md: "14px",
        sm: "14px",
      },
    },
    discount: {
      fontFamily: theme.v2.typography.bodyText1.family,
      color: theme.v2.color.onBackground,
      fontWeight: theme.v2.typography.bodyText1.weight,
      fontSize: {
        lg: "14px",
        md: "14px",
        sm: "14px",
      },
    },
    source: {
      fontFamily: theme.v2.typography.bodyText1.family,
      color: "#828282",
      fontWeight: theme.v2.typography.bodyText1.weight,
      fontSize: {
        lg: "12px",
        md: "12px",
        sm: "12px",
      },
    },
  },
});

const getNoResultsStyles = (theme) => ({
  logo: {
    backgroundColor: "#fff",
    color: theme.v2.color.primary,
    borderRadius: "0px",
  },
  titleText: {
    fontFamily: theme.v2.typography.title1.family,
    color: theme.v2.color.onBackground,
    fontWeight: theme.v2.typography.title1.weight,
    fontSize: {
      lg: "20px",
      md: "20px",
      sm: "20px",
    },
  },
  detailText: {
    fontFamily: theme.v2.typography.bodyText1.family,
    color: theme.v2.color.onBackground,
    fontWeight: theme.v2.typography.bodyText1.weight,
    fontSize: {
      lg: "16px",
      md: "16px",
      sm: "12px",
    },
  },
});

const headerStyles = (theme) => ({
  title: {
    fontFamily: theme.v2.typography.title1.family,
    color: theme.v2.color.primary,
    fontWeight: theme.v2.typography.title1.weight,
    fontSize: {
      lg: theme.v2.typography.title1.size.lg,
      md: theme.v2.typography.title1.size.md,
      sm: theme.v2.typography.title1.size.md,
    },
  },
  description: {
    root: {
      fontFamily: theme.v2.typography.bodyText1.family,
      fontSize: {
        lg: theme.v2.typography.bodyText1.size.lg,
        md: theme.v2.typography.bodyText1.size.md,
        sm: theme.v2.typography.bodyText1.size.md,
      },
    },
    text: {
      fontWeight: theme.v2.typography.bodyText1.weight,
      color: theme.v2.color.onBackground,
    },
  },
});

const Container = styled.div`
  margin-top: ${({theme}) => theme.v2.spacing(4)};
`;
